import { render } from "./StartTodaySection.vue?vue&type=template&id=73da8d96&scoped=true"
import script from "./StartTodaySection.vue?vue&type=script&lang=js"
export * from "./StartTodaySection.vue?vue&type=script&lang=js"

import "./StartTodaySection.vue?vue&type=style&index=0&id=73da8d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73da8d96"]])

export default __exports__